import { useCurrentSubscriptionApi } from '@aibees/shared/features/price-and-plan/api/use-current-subscription-api';
import { classnames, fDate, fHumanReadableNumber } from '@aibees/shared/utils';
import { Typography } from '@mui/material';
import { memo } from 'react';
import * as Styled from './styles';
import * as SX from './sx';
import type { AccountPopoverCreditPlanDetailProps as Props } from './types';

export const AccountPopoverCreditPlanDetail = memo(
  ({ className, toRoute }: Props) => {
    const { data } = useCurrentSubscriptionApi();

    const ranOutOfCredit = data?.credit?.total === 0;

    const textWithCredit = `Use
          ${fHumanReadableNumber(Number(data?.credit?.total) || 0)}
          Credits until`;

    const textWithNoCredit = 'Next Charge in';

    return (
      <Styled.Wrapper
        className={classnames('AccountPopoverCreditPlanDetail', className)}
        sx={SX.root}
        gap={0.5}
        alignItems="center"
      >
        <Typography variant="body4" fontWeight={500} color="grey.700">
          {ranOutOfCredit ? textWithNoCredit : textWithCredit}
        </Typography>
        {/* <AccountRemainingTime /> */}
        <Typography variant="body4" fontWeight={700} color="grey.800">
          {fDate(data?.current?.currentPeriodEnd)}
        </Typography>
      </Styled.Wrapper>
    );
  }
);

AccountPopoverCreditPlanDetail.displayName = 'AccountPopoverCreditPlanDetail';
